import styled from "styled-components";

const Wrapper = styled.section`
  .profile-container {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    max-width: 600px;
    margin: auto;
    padding: 2rem;
    background: #f9f9f9;
    border-radius: 8px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  }

  .profile-card {
    background: white;
    padding: 1.5rem;
    border-radius: 8px;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
  }

  h2, h3 {
    margin-bottom: 0.5rem;
  }

  p {
    font-size: 1rem;
    color: #555;
  }

  .features-container {
    background: white;
    padding: 1.5rem;
    border-radius: 8px;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    padding: 0.5rem 0;
    font-size: 1rem;
    border-bottom: 1px solid #eee;
  }

  li:last-child {
    border-bottom: none;
  }
`;

export default Wrapper;